import React from 'react'
import styled from "styled-components";
import Search from './Search';
import ExtraFilters from './ExtraFilters';

const Container = styled.div`
    border: solid 1px #ccc;
    padding: 10px 15px;
    margin: 10px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

function TableFilter(props) {
    const {data, column, isBulk, disabled, onSubmit} = props

    return (
        <Container>
            <Search />
            <ExtraFilters data={data} column={column} isBulk={isBulk} disabled={disabled} onSubmit={onSubmit}/>
        </Container>
    )
}

TableFilter.propTypes = {
}

export default TableFilter
